export default {"src":"/_next/static/media/image-question.ac0b018a.svg","height":141,"width":153};